import * as React from 'react'
import * as Yup from 'yup'
import { Paper, Grid, TextField, Button, Typography } from '@mui/material'
import PageTitle from '../../components/title/PageTitle'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useState, useEffect } from 'react'
import AxiosClient from '../../utils/axios'
import { useNavigate, useParams } from 'react-router-dom'
import LoadingBar from '../../components/loading/LoadingBar'
import ErrorMessage from '../../utils/errorMessage'
import HttpErrorNotification from '../../components/notifications/HttpErrorNotification'
import Breadcrumb from '../../components/breadcrumb/Breadcrumb'

export default function EditCategory() {
  const navigate = useNavigate()
  const params = useParams()
  const [sendRequest, setSendRequest] = useState(false)
  const [alert, setAlert] = useState({ state: false, message: '' })

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Kategoriya nomini yozing'),
    name_uz: Yup.string(),
    name_ru: Yup.string(),
    name_eng: Yup.string(),
    description: Yup.string().required('Izoh yozing'),
  })
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  const onSubmit = async ({ name, name_uz, name_ru, name_eng, description }) => {
    try {
      await AxiosClient.put(`/category/${params.categoryId}`, {
        name,
        name_uz,
        name_ru,
        name_eng,
        description,
      })
      navigate('/category')
    } catch (error) {
      const message = ErrorMessage(error)
      setAlert({
        state: true,
        message,
      })
      setSendRequest(false)
    }
  }

  const fetch = async () => {
    const result = await AxiosClient.get(`/category/${params.categoryId}`)
    return result.data
  }

  useEffect(() => {
    setSendRequest(true)
    fetch()
      .then(
        (data) => {
          setValue('name', data.name)
          setValue('name_uz', data.name_uz)
          setValue('name_ru', data.name_ru)
          setValue('name_eng', data.name_eng)
          setValue('description', data.description)
        },
        (error) => {
          const message = ErrorMessage(error)
          setAlert({
            state: true,
            message,
          })
        },
      )
      .then(() => setSendRequest(false))
  }, [])

  return (
    <Paper sx={{ p: 1 }}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <PageTitle title="Kategoriyani o'zgartirish" />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            id="name"
            name="name"
            label="Kategoriya nomi"
            {...register('name')}
            error={errors.name ? true : false}
            InputLabelProps={{ shrink: true }}
          />
          <Typography variant="inherit" color="textSecondary">
            {errors.name?.message}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <TextField
            id="name_uz"
            name="name_uz"
            label="Kategoriya nomi (O'zbekcha)"
            {...register('name_uz')}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            id="name_ru"
            name="name_ru"
            label="Kategoriya nomi (Русский)"
            {...register('name_ru')}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            id="name_eng"
            name="name_eng"
            label="Kategoriya nomi (English)"
            {...register('name_eng')}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            required
            id="description"
            name="description"
            label="Izoh"
            {...register('description')}
            error={errors.description ? true : false}
            InputLabelProps={{ shrink: true }}
          />
          <Typography variant="inherit" color="textSecondary">
            {errors.description?.message}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit(onSubmit)}
          >
            Saqlash
          </Button>
        </Grid>
        <Grid item xs={12}>
          {alert.state ? (
            <HttpErrorNotification message={alert.message} />
          ) : (
            <></>
          )}
        </Grid>

        {sendRequest ? <LoadingBar /> : <></>}
        <Breadcrumb />
      </Grid>
    </Paper>
  )
}
